// extracted by mini-css-extract-plugin
export default {"tableCell":"DataGrid_tableCell__4uZ4t","tableCellImg":"DataGrid_tableCellImg__62cBS"};